module.exports = __webpack_public_path__ + "img/codepen.png";